/* rs10-restriction.js */
(function () {
  const cfg = window.rs10RestrictionConfig || {};
  if (!cfg.enabled) return;

  const substring = (cfg.substring || '').toString().trim().toLowerCase();
  const minOrder = Number(cfg.minOrder || 0);
  const currency = cfg.shopCurrency || '';

  if (!substring) return;

  // --- Global state ---
  let isChecking = false;
  let lastCheck = 0;
  let activeObservers = [];

  // --- Helpers ---
  function debounce(fn, wait = 200) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) {
      console.error('rs10: fetchCart error', e);
      return null;
    }
  }

  function isItemFlagged(item) {
    const title = (item.product_title || item.title || '').toString().toLowerCase();
    return title.indexOf(substring) !== -1;
  }

  function removeBanner() {
    const existing = document.getElementById('rs10-warning');
    if (existing) existing.remove();
  }

  function showBanner(htmlMessage) {
    removeBanner();
    const banner = document.createElement('div');
    banner.id = 'rs10-warning';
    banner.setAttribute('role', 'status');
    banner.style.cssText = 'background:#fff3cd;border:1px solid #ffeeba;color:#856404;padding:12px;margin:12px 0;border-radius:6px;font-size:14px;';
    banner.innerHTML = `<strong>Doesn’t meet criteria:</strong> ${htmlMessage}`;

    const possibleContainers = [
      document.querySelector('.cart__form'),
      document.querySelector('.cart'),
      document.querySelector('.drawer__content'),
      document.querySelector('.cart-items'),
      document.querySelector('cart-drawer'), // NEW
      document.querySelector('main'),
      document.body
    ];
    const container = possibleContainers.find(Boolean);
    if (container && container.firstChild) container.insertBefore(banner, container.firstChild);
    else document.body.prepend(banner);
  }

  function findCheckoutControls() {
    return Array.from(document.querySelectorAll( 
      'a[href*="/checkout"], button[name="checkout"],button[id="CartDrawer-Checkout"], a[href^="/checkout"], button.checkout, .cart__checkout, .cart__submit, .cart-drawer__checkout'
    ));
  }

  // --- Popup ---
  function ensurePopup() {
   // debugger;
    if (document.getElementById('rs10-popup')) return;
    const popup = document.createElement('div');
    popup.id = 'rs10-popup';
    popup.className = "hidden fixed inset-0 z-50 flex items-center justify-center bg-black/50";
    popup.innerHTML = `
<div class="rs10-popu_inner">
      <div class="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
        <button id="rs10-popup-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700">&times;</button>
        <h2 class="text-lg font-semibold mb-4">Doesn’t meet criteria</h2>
        <p id="rs10-popup-message" class="text-sm text-gray-700"  style="white-space: pre-line;"></p> 
        <button id="rs10-popup-close-new" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700">OK</button>
      </div>
    </div>
      `;
    document.body.appendChild(popup);

    document.getElementById('rs10-popup-close').addEventListener('click', () => {
      popup.classList.add('hidden');
    });
     document.getElementById('rs10-popup-close-new').addEventListener('click', () => {
      popup.classList.add('hidden');
    });
    popup.addEventListener('click', (e) => {
      if (e.target.id === 'rs10-popup') popup.classList.add('hidden');
    });
  }

  function showPopup(message) {
    disableCheckoutUI(message);
    ensurePopup();
    document.getElementById('rs10-popup-message').textContent = message;
    document.getElementById('rs10-popup').classList.remove('hidden');
  }

  function disableCheckoutUI(message) {
   // debugger;
    const controls = findCheckoutControls();
    controls.forEach(ctrl => {
      if (!ctrl.dataset.rs10OrigText) ctrl.dataset.rs10OrigText = ctrl.textContent.trim();
      ctrl.textContent = "You are not Eligible";
      ctrl.removeAttribute('disabled');

      if (!ctrl.rs10ClickHandler) {
        ctrl.rs10ClickHandler = function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showPopup(message || "You are not eligible to checkout.");
        };
        ctrl.addEventListener('click', ctrl.rs10ClickHandler);
      }
    });
    if (message) showBanner(message);
  }

  function enableCheckoutUI() {
   // debugger;
    const controls = findCheckoutControls();
    controls.forEach(ctrl => {
      if (ctrl.dataset.rs10OrigText) {
        ctrl.textContent = ctrl.dataset.rs10OrigText;
        ctrl.removeAttribute('disabled');
        delete ctrl.dataset.rs10OrigText;
      }
      if (ctrl.rs10ClickHandler) {
        ctrl.removeEventListener('click', ctrl.rs10ClickHandler);
        delete ctrl.rs10ClickHandler;
      }
    });
    removeBanner();
  }

  // --- Main logic ---
  async function checkCartState() {
   // debugger;
    const now = Date.now();
    if (isChecking || (now - lastCheck < 500)) return;
    isChecking = true;
    lastCheck = now;

    activeObservers.forEach(({ observer }) => observer.disconnect());

    const cart = await fetchCart();
    if (!cart) {
      isChecking = false;
      activeObservers.forEach(({ observer, el }) => observer.observe(el, { childList: true, subtree: true }));
      return;
    }

    const flaggedLines = cart.items.filter(isItemFlagged);
    const totalFlaggedQty = flaggedLines.reduce((s, i) => s + (i.quantity || 0), 0);
    const subtotalCents = Number(cart.items_subtotal_price || cart.total_price || 0);
    const requiredCents = Math.round(minOrder * 100);

    if (totalFlaggedQty > 1 || flaggedLines.length > 1) {
     // const message = `Only 1 "${cfg.substring}" product is allowed per order. Please remove extra "${cfg.substring}" items.`;
     const message = `Cannot add more than 1 "${cfg.substring}" item to cart \n For "${cfg.substring}" Deal, only 1 product per customer is allowed`;
      disableCheckoutUI(message);
    } else if (totalFlaggedQty === 1 && subtotalCents < requiredCents) {
     // const message = `Checkout blocked with a "${cfg.substring}" product in cart. Add more to reach ${minOrder} ${currency}, or remove it.`;
      const message = ` Minimum Order Value is ${minOrder} ${currency} . Please add another product to the cart`;
      disableCheckoutUI(message);
    } else {
      enableCheckoutUI();
    }

    activeObservers.forEach(({ observer, el }) => observer.observe(el, { childList: true, subtree: true }));
    isChecking = false;
  }

  // --- Product page restriction ---
  function interceptProductForm() {
    function pageIsRestricted() {
      const titleEl = document.querySelector('h1.product__title, .product__title, [data-product-title]');
      if (titleEl) return (titleEl.textContent || '').toLowerCase().indexOf(substring) !== -1;
      return false;
    } 

    document.addEventListener('submit', function (e) {
     // debugger;
    
      const form = e.target;
      
      if (!form || !(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      const action = (form.getAttribute('action') || '').toLowerCase();
      if (!(action.startsWith('/cart') || action.indexOf('/cart/add') !== -1)) return;

      if (!pageIsRestricted()) return;

     e.preventDefault();
          e.stopImmediatePropagation();

      let qty = 1;
      const qtyInput = form.querySelector('input[name="quantity"], input[id^="Quantity-"], input.quantity');
      if (qtyInput) qty = parseInt(qtyInput.value || '1', 10) || 1;

      if (qty > 1) {
        showBanner(`Only 1 "${cfg.substring}" product allowed per order. Set quantity to 1.`);
        return;
      }

      fetchCart().then(cart => {
        e.preventDefault();
          e.stopImmediatePropagation();
        const existingFlaggedQty = (cart && cart.items ? cart.items.filter(isItemFlagged).reduce((s, i) => s + (i.quantity || 0), 0) : 0);
        if (existingFlaggedQty > 0) {
          showBanner(`You already have a "${cfg.substring}" product in your cart. Remove it if you want to add this one.`);
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open();
          const msg = document.querySelector('#rs10checkoutmsg');
          if (msg) {
            msg.style.animation = 'none';

            void msg.offsetWidth;

            msg.textContent = `Only 1 "${cfg.substring}" allow product in your cart`;

            msg.style.animation = 'fadeAndCollapse 5s forwards';
          } 

       //   document.getElementById('CartDrawer-Checkout').click();
        /* const checkoutBtn = document.querySelector('button[name="checkout"][form="CartDrawer-Form"]');
          if (!checkoutBtn) {
          } else{
            checkoutBtn.click();
           } */
        //  showPopup(message || "You are not eligible to checkout.");
          return;
        }

        try { form.submit(); }
        catch (err) {
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: new FormData(form)
          }).then(() => setTimeout(checkCartState, 600))
            .catch(e => console.error('rs10 add fallback error', e));
        }
      });
    }, { capture: true });
  }

  // --- Listeners ---
  function setupListeners() {
    document.addEventListener('change', debounce(function (e) {
    //  debugger;
      const t = e.target;
      if (t && t.matches('input[name="quantity"], input[id^="Quantity-"], input[id^="Drawer-quantity-"], input.quantity')) {  //Drawer-quantity-1
        setTimeout(checkCartState, 300);
      }
    }, 250));

    // Add observers for both page cart + drawer
    const selectors = [
      '.cart__items', '.cart-items', '.drawer__contents', '.cart__form', '.cart', 
      'cart-drawer', '.cart-drawer__contents'
    ];
    selectors.forEach(sel => {
      const el = document.querySelector(sel);
      if (!el) return;
      const observer = new MutationObserver(debounce(checkCartState, 500));
      observer.observe(el, { childList: true, subtree: true });
      activeObservers.push({ observer, el });
    });

    // Hook Shopify events
    document.addEventListener('cart:updated', () => setTimeout(checkCartState, 200));
    document.addEventListener('ajaxCart:updated', () => setTimeout(checkCartState, 200));
    window.addEventListener('load', () => setTimeout(checkCartState, 400));
  }

  interceptProductForm();
  setupListeners();
})();
